<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  address: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['back', 'exit']);
const { t } = useI18n();
const street = computed(
  () => props.address?.logradouro || props.address?.endereco || ''
);
const addressLine = computed(() => {
  const number = props.address?.numero;
  const suffixes = [props.address?.unidade, props.address?.complemento]
    .filter(Boolean)
    .map(value => `/ ${value}`);

  return [number ? `${street.value}, ${number}` : street.value, ...suffixes]
    .filter(Boolean)
    .join(' ');
});
const hasAddress = computed(() => Boolean(street.value));
const locality = computed(() =>
  [props.address?.bairro, props.address?.cidade].filter(Boolean).join(' - ')
);
</script>

<template>
  <div>
    <header
      v-if="hasAddress"
      class="border-b border-lais-border-soft bg-white shadow-[0_0_6px_rgb(0_0_0_/_0.02),0_2px_4px_rgb(0_0_0_/_0.08)]"
      data-test="sales-registration-header"
    >
      <div class="mx-auto w-full max-w-[1160px] p-5 max-md:p-[15px]">
        <nav class="flex items-center justify-between max-md:hidden">
          <LaisPrimaryButton
            variant="link"
            icon="i-lucide-arrow-left"
            data-test="sales-registration-header-back"
            @click="emit('back')"
          >
            {{ t('SALES.ACTIONS.BACK') }}
          </LaisPrimaryButton>
          <LaisPrimaryButton
            variant="ghost"
            icon="i-lucide-log-out"
            data-test="sales-registration-header-exit"
            @click="emit('exit')"
          >
            {{ t('SALES.REGISTRATION.SAVE_AND_EXIT') }}
          </LaisPrimaryButton>
        </nav>
        <div class="mb-[19px]">
          <h1
            class="my-4 font-redHatDisplay text-[32px] font-bold leading-9 text-lais-text max-md:hidden"
          >
            {{ t('SALES.REGISTRATION.HEADING') }}
          </h1>
          <div class="text-lais-text-muted">
            <div v-if="locality" class="flex items-center gap-1.5 text-sm">
              <span class="i-lucide-map-pin size-5 text-lais-primary" />
              <span data-test="sales-registration-header-locality">
                {{ locality }}
              </span>
            </div>
            <p
              class="mt-[3px] ml-[26px] text-xl leading-6 text-lais-text max-md:ml-0 max-md:text-[0.875rem] max-md:leading-5"
              data-test="sales-registration-header-address"
            >
              {{ addressLine }}
            </p>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
